import styled from 'styled-components';

export const Select = styled.div`
  position: relative;
`;
